import { StatusCodes } from "http-status-codes";

import { statusMiddleware, UnauthorizedException } from "@eisox/api";

const listeners = new Set<() => void>();

/** Server rejected the token. Emitted from transport, outside React. */
const notifySessionRevoked = () => {
  for (const listener of listeners) listener();
};

const onSessionRevoked = (listener: () => void) => {
  listeners.add(listener);
  return () => {
    listeners.delete(listener);
  };
};

/**
 * Maps 401 to a session revocation notification, then throws. The exception still
 * reaches the caller; AuthProvider signs out in parallel via its subscription.
 */
const sessionRevokedMiddleware = statusMiddleware({
  [StatusCodes.UNAUTHORIZED]: () => {
    notifySessionRevoked();
    throw new UnauthorizedException();
  },
});

export { onSessionRevoked, sessionRevokedMiddleware };
